<template lang="pug">
div
  .analise
    .between
      el-menu(
        default-active='analise',
        mode='horizontal',
        @select='changeSelect'
      )
        el-menu-item(index='analise') {{`${tituloAnalise} ${numeroProcesso}`}}
        el-menu-item(index='mae', v-if="tipo === 'PEAS_FILHO'") {{`Processo Assentamento ${processoMae.numeroProcesso}`}}
        el-menu-item(index='separate', v-if="showSeparate") Análise do Processo
      div(v-if="idProcesso")
        app-opcoes-header-analise(
          :idProcesso="idProcesso"
          :numeroProcesso="numeroProcesso"
          :statusProcesso="statusProcesso"
          :opcoesHeader="opcoesHeader",
          :tipoProcesso="tipo",
          :protocolo="numeroProtocolo",
          :idDespacho="idDespacho",
          :isEmissaoCertidao="isEmissaoCertidao"
          :btnPendencia="visualizarBotaoSinalizarPendencia"
          :btnRetificacao="btnSolicitarRetificacao",
          :btnNotificarInteressado="btnNotificarInteressado"
        )
    div(v-if="selected === 'analise'")
      slot(name="analise")
    div(v-else-if="selected === 'mae'")
      slot(name="mae")
    div(v-else="selected === 'separate'")
      slot(name="separate")
    div(v-else="selected === 'titulo'")
      slot(name="titulo")
</template>

<script>
import AppOpcoesHeaderAnalise from '../modal/AppOpcoesHeaderAnalise'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppOpcoesHeaderAnalise
  },

  props: {
    idProcesso: {
      required: true
    },
    statusProcesso: {
      required: false
    },
    numeroProcesso: {
      type: String,
      required: true
    },
    tituloAnalise: {
      type: String,
      required: false
    },
    showMessages: {
      type: Boolean,
      required: false
    },
    setor: {
      type: String,
      required: false
    },
    tipo: {
      type: String,
      required: true
    },
    showSeparate: {
      type: Boolean,
      required: false
    },
    opcoesHeader: {
      type: Boolean,
      required: false
    },
    numeroProtocolo: {
      type: String
    },
    idDespacho: {
      required: false
    },
    btnSolicitarInformacao: {
      required: false
    },
    btnSolicitarRetificacao: {
      type: Boolean,
      required: false,
      default: true
    },
    btnNotificarInteressado: {
      type: Boolean,
      required: false,
      default: true
    },
    isEmissaoCertidao: {
      default: true
    }
  },

  data () {
    return {
      cadastro: {},
      processo: {},
      processoMae: '',
      titulo: '',
      isPossuiTitulo: true,
      selected: 'analise',
      hasConversa: undefined,
      tituloInformacao: '',
      visualizarBotaoSinalizarPendencia: regrasAnalise.visualizarBotaoSinalizarPendencia
    }
  },

  methods: {
    changeSelect (key) {
      this.selected = key
    }
  }
}
</script>

<style scoped lang="scss">

  .label {
    font-weight: bold;
    color: #424242;
  }

  .titulo-analise {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: solid 1px #e6e6e6;
  }

  .center {
    display: flex;
    align-items: center;
  }

  .color {
    background-color: #104F55;
    border: solid #104F55 1px;
  }

  .btn {
    padding: 7px;
    margin-bottom: 10px;
  }

  .icon {
    font-size: 16px;
  }

  .analise {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .between {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/screens/analise/components/shared/AppAnaliseHeader.vue